"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineObject4ToJSON = exports.InlineObject4FromJSONTyped = exports.InlineObject4FromJSON = void 0;
const runtime_1 = require("../runtime");
function InlineObject4FromJSON(json) {
    return InlineObject4FromJSONTyped(json, false);
}
exports.InlineObject4FromJSON = InlineObject4FromJSON;
function InlineObject4FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'asset': json['asset'],
        'name': !runtime_1.exists(json, 'name') ? undefined : json['name'],
        'description': !runtime_1.exists(json, 'description') ? undefined : json['description'],
        'urlExtension': !runtime_1.exists(json, 'urlExtension') ? undefined : json['urlExtension'],
    };
}
exports.InlineObject4FromJSONTyped = InlineObject4FromJSONTyped;
function InlineObject4ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'asset': value.asset,
        'name': value.name,
        'description': value.description,
        'urlExtension': value.urlExtension,
    };
}
exports.InlineObject4ToJSON = InlineObject4ToJSON;
